@if (formGroup(); as fg) {
  <form [formGroup]="fg" (ngSubmit)="onSave()">
    <p-card header="Dane podstawowe" class="custom-card">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="flex flex-col gap-2">
          <label for="rule-id" appRequiredLabel="id" class="field-label">
            Identyfikator
          </label>
          <input id="rule-id" pInputText formControlName="id" readonly />
        </div>

        <div class="flex flex-col gap-2">
          <label
            for="rule-created-at"
            appRequiredLabel="dataUtworzenia"
            class="field-label"
          >
            Data utworzenia
          </label>
          <p-date-picker
            inputId="rule-created-at"
            class="w-full customDatePicker"
            dateFormat="yy-mm-dd"
            [showTime]="true"
            hourFormat="24"
            [showIcon]="true"
            [iconDisplay]="'input'"
            appendTo="body"
            formControlName="dataUtworzenia"
          ></p-date-picker>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        <div class="flex flex-col gap-2">
          <label
            for="rule-date-from"
            appRequiredLabel="dataOd"
            class="field-label"
          >
            Data początku obowiązywania
          </label>
          <p-date-picker
            inputId="rule-date-from"
            class="w-full customDatePicker"
            dateFormat="yy-mm-dd"
            [showTime]="true"
            hourFormat="24"
            [readonlyInput]="true"
            [showIcon]="true"
            [iconDisplay]="'input'"
            appendTo="body"
            formControlName="dataOd"
            [minDate]="minDate()"
          ></p-date-picker>
        </div>

        <div class="flex flex-col gap-2">
          <label for="rule-data-do" class="field-label">
            Data końca obowiązywania
          </label>
          <p-date-picker
            inputId="rule-data-do"
            class="w-full customDatePicker"
            dateFormat="yy-mm-dd"
            [showTime]="true"
            hourFormat="24"
            [readonlyInput]="true"
            [showIcon]="true"
            [iconDisplay]="'input'"
            appendTo="body"
            formControlName="dataDo"
          ></p-date-picker>
        </div>
      </div>

      <div class="mt-6 flex flex-col gap-2">
        <label
          id="rule-content-label"
          appRequiredLabel="tresc"
          class="field-label"
        >
          Treść
        </label>

        <div appRemoveQuillTooltip>
          <p-editor
            id="rule-content"
            formControlName="tresc"
            [style]="{ height: '200px' }"
            class="rule-editor"
            appControlError
            aria-labelledby="rule-content-label"
          >
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <select class="ql-size" aria-label="Wielkość czcionki">
                  <option value="small">Mała</option>
                  <option selected>Średnia</option>
                  <option value="large">Duża</option>
                </select>
              </span>
              <span class="ql-formats">
                <button
                  class="ql-bold"
                  aria-label="Pogrubienie"
                  type="button"
                ></button>
                <button
                  class="ql-italic"
                  aria-label="Pochylenie"
                  type="button"
                ></button>
                <button
                  class="ql-underline"
                  aria-label="Podkreślenie"
                  type="button"
                ></button>
              </span>
              <span class="ql-formats">
                <select class="ql-color" aria-label="Kolor czcionki"></select>
              </span>
              <span class="ql-formats">
                <button
                  class="ql-list"
                  value="ordered"
                  aria-label="Numerowanie"
                  type="button"
                ></button>
                <button
                  class="ql-list"
                  value="bullet"
                  aria-label="Wypunktowanie"
                  type="button"
                ></button>
              </span>
              <span class="ql-formats">
                <select class="ql-align" aria-label="Wyrównanie tekstu">
                  <option selected></option>
                  <option value="center"></option>
                  <option value="right"></option>
                  <option value="justify"></option>
                </select>
              </span>
            </ng-template>
          </p-editor>
        </div>
      </div>
    </p-card>

    <div class="flex flex-wrap justify-end gap-2 mt-6">
      <p-button
        type="button"
        label="Anuluj"
        styleClass="customInfoButton outlined"
        (click)="onCancel()"
        [disabled]="isSubmitting()"
      />
      <p-button
        label="Zapisz i zamknij"
        styleClass="customInfoButton"
        type="submit"
        [disabled]="isSubmitting()"
      />
    </div>
  </form>
}
